import { cn } from '@core/utils';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

const Root = ({
  dir = 'rtl',
  ...props
}: DropdownMenuPrimitive.DropdownMenuProps) => (
  <DropdownMenuPrimitive.Root dir={dir} {...props} />
);
const Trigger = DropdownMenuPrimitive.Trigger;
const Portal = DropdownMenuPrimitive.Portal;
const Content = ({
  align = 'start',
  className,
  ...props
}: DropdownMenuPrimitive.DropdownMenuContentProps) => (
  <DropdownMenuPrimitive.Content
    align={align}
    className={cn(
      'py-12 shadow-xl',
      'data-[state=open]:animate-in data-[state=closed]:animate-out',
      'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
      'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
      'data-[side=bottom]:slide-in-from-top-2',
      'data-[side=left]:slide-in-from-right-2',
      'data-[side=right]:slide-in-from-left-2',
      'data-[side=top]:slide-in-from-bottom-2',
      'transition-all duration-200',
      className,
    )}
    {...props}
  />
);
const Label = DropdownMenuPrimitive.Label;
const Item = ({
  className,
  dir = 'ltr',
  role = 'button',
  ...props
}: DropdownMenuPrimitive.DropdownMenuItemProps) => (
  <DropdownMenuPrimitive.Item
    className={cn(
      'relative flex cursor-pointer select-none items-center px-16 py-8 font-400 outline-none typo-body3',
      'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      'hover:bg-B-50 focus:bg-B-50',
      'data-[highlighted]:bg-B-50',
      'transition-colors duration-200',
      className,
    )}
    dir={dir}
    role={role}
    {...props}
  />
);
const Group = DropdownMenuPrimitive.Group;
const CheckboxItem = DropdownMenuPrimitive.CheckboxItem;
const ItemIndicator = DropdownMenuPrimitive.ItemIndicator;
const RadioGroup = DropdownMenuPrimitive.RadioGroup;
const RadioItem = DropdownMenuPrimitive.RadioItem;
const Sub = DropdownMenuPrimitive.Sub;
const SubTrigger = DropdownMenuPrimitive.SubTrigger;
const SubContent = DropdownMenuPrimitive.SubContent;
const Separator = DropdownMenuPrimitive.Separator;
const Arrow = DropdownMenuPrimitive.Arrow;

/**
 * @deprecated organism 에 있는 DropdownMenu 를 사용해주세요
 */
export const Dropdown = {
  Root,
  Trigger,
  Portal,
  Content,
  Label,
  Item,
  Group,
  CheckboxItem,
  ItemIndicator,
  RadioGroup,
  RadioItem,
  Sub,
  SubTrigger,
  SubContent,
  Separator,
  Arrow,
};
